import { AnyAction } from 'redux';
import { sanitizeText } from '@/utils/text/sanitizeText';
import {
  isDraftConfigurationWithTextOrSpecialText,
  isDraftSpecialTextConfiguration,
} from '@/model/configuration/isDraftConfigurationType';
import { fetchSpecialFontTask, getSpecialFontTask } from '@/model/font/fetchSpecialFontTask';
import { getDraftDispatch } from '@/redux/draft/draftDispatch';
import { Thunk } from '@/redux/types';
import { setTextAction } from '@/components/draft/draftState/actions/setTextAction';
import { withoutHistory } from '@/components/draft/draftState/history/withoutHistory';
import { DraftAction } from '@/components/draft/draftState/types';
import { getConfiguration } from '../getters/getConfiguration';
import { matchTextAgainstBlocklistAction } from './matchTextAgainstBlocklistAction';

export const setConfigurationText =
  (cid: number, text: string): Thunk<void, AnyAction> =>
  (dispatch, getState) => {
    const state = getState();
    const configuration = getConfiguration(state, cid);

    if (!isDraftConfigurationWithTextOrSpecialText(configuration)) {
      // configuration had been removed before debounced text update was called
      return;
    }

    const sanitizedText = sanitizeText(text);
    const configurationText = configuration.text;

    if (configurationText.content === sanitizedText) {
      return;
    }

    let action: DraftAction;
    if (isDraftSpecialTextConfiguration(configuration)) {
      const {
        font: { id: fontId },
        textAlign,
      } = configurationText.style;
      const specialFontTask = getSpecialFontTask(fontId, textAlign, sanitizedText);

      if (specialFontTask) {
        action = setTextAction(configuration, text, specialFontTask);
      } else {
        // if we don't have the specialFontTask ready, the setSpecialFontTaskAction should add this to the history
        action = withoutHistory(setTextAction(configuration, text));
        dispatch(fetchSpecialFontTask(fontId, textAlign, sanitizedText, configuration)).catch(
          () => {
            /* ignore failed fetchSpecialFontTask */
          }
        );
      }
    } else {
      action = setTextAction(configuration, text);
    }

    getDraftDispatch(state)(action);
    dispatch(matchTextAgainstBlocklistAction(configuration, sanitizedText));
  };
